export enum BalanceSourceEnum {
  /** Balance source from 1C */
  ONE_C = 'ONE_C',
  /** Balance source from bank */
  BANK = 'BANK',
}